import { List, Map } from "immutable";

import { Action } from "common/types/redux";

import { AccessorRole } from "seneca-common/features/class/state";

import actionTypes from "../action-types";
import ClassEnrollment from "../models/ClassEnrollment";
import { ClassEnrollments } from "../models/ClassEnrollments";
import ClassTeacher from "../models/ClassTeacher";

export default function classEnrollmentsReducer(
  enrollments: ClassEnrollments = List(),
  action: Action<Record<string, any>>
): ClassEnrollments {
  switch (action.type) {
    case actionTypes.RECEIVE_CLASS_ENROLLMENTS:
      return List(action.payload!.enrollments.map(parseClassEnrollment));

    case actionTypes.RECEIVE_CLASS_ENROLLMENT: {
      return enrollments.push(parseClassEnrollment(action.payload!.enrollment));
    }

    case actionTypes.DELETE_CLASS_ENROLLMENT:
      return enrollments.filter(
        (enrollment: ClassEnrollment) =>
          enrollment.classId !== action.payload!.classId
      );

    default:
      return enrollments;
  }
}

export function childClassEnrollmentsReducer(
  enrollments: ClassEnrollments = List(),
  action: Action<Record<string, any>>
): ClassEnrollments {
  switch (action.type) {
    case actionTypes.RECEIVE_CHILD_CLASS_ENROLLMENTS:
      return enrollments.concat(
        List(action.payload!.enrollments.map(parseClassEnrollment))
      );

    default:
      return enrollments;
  }
}

export function parseClassEnrollment(enrollment: Record<string, any>) {
  const owner = enrollment.teachers.find(
    (item: any) => item.role === AccessorRole.owner
  );

  return new ClassEnrollment({
    ...enrollment,
    courseIds: List(enrollment.courseIds),
    teacherName: owner && owner.name,
    teachers: enrollment.teachers.reduce(
      (map: any, val: any) => map.set(val.userId, new ClassTeacher(val)),
      Map()
    ),
    enrollmentUserIds: List(
      enrollment.enrollments.map(({ userId }: { userId: string }) => userId)
    ),
    isClassManaged: !!enrollment.managedBy
  });
}
